import { render, staticRenderFns } from "./OfferListTableDetails.NoAnalytics.vue?vue&type=template&id=0884fdc0&scoped=true"
import script from "./OfferListTableDetails.NoAnalytics.vue?vue&type=script&lang=js"
export * from "./OfferListTableDetails.NoAnalytics.vue?vue&type=script&lang=js"
import style0 from "./OfferListTableDetails.NoAnalytics.vue?vue&type=style&index=0&id=0884fdc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0884fdc0",
  null
  
)

export default component.exports